import { render, staticRenderFns } from "./contas-a-pagar.vue?vue&type=template&id=2920d14f&"
import script from "./contas-a-pagar.vue?vue&type=script&lang=js&"
export * from "./contas-a-pagar.vue?vue&type=script&lang=js&"
import style0 from "./contas-a-pagar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports